// removed by extract-text-webpack-plugin
module.exports = {"border":"border__kapPa","white":"white__3DUkp","black":"black__3EVBP","red":"red__3Da0C"};


//////////////////
// WEBPACK FOOTER
// ./components/border/border.css
// module id = Y6Xg
// module chunks = 0